import { motion } from "framer-motion";
import { Home, Building2, HardHat, Sparkles, Wrench } from "lucide-react";

const services = [
{id:"murs",title:"Lavage des murs et plafonds",short:"Du sol au plafond",long:"Un nettoyage des murs et plafonds adapt\u00e9 \u00e0 vos surfaces.",icon:Home,image:"/walls.png",span:"md:col-span-4"},
{id:"demenagement",title:"Apr\u00e8s d\u00e9m\u00e9nagement",short:"Un nouveau d\u00e9part",long:"Nettoyage des espaces apr\u00e8s un d\u00e9m\u00e9nagement, avant de reprendre possession des lieux.",icon:Home,image:"/moving.png",span:"md:col-span-4"},
{id:"construction",title:"Apr\u00e8s construction",short:"La touche finale",long:"Nettoyage apr\u00e8s travaux pour retrouver des espaces propres et accueillants.",icon:HardHat,image:"/post-construction.png",span:"md:col-span-4"},
{id:"vitres",title:"Lavage de vitres et tapis",short:"Clart\u00e9 et fra\u00eecheur",long:"Entretien des vitres et nettoyage des tapis pour rafra\u00eechir vos espaces.",icon:Sparkles,image:"/window-cleaning.png",span:"md:col-span-4"},
{id:"locatif",title:"Logements locatifs",short:"Entre deux occupations",long:"Nettoyage de vos logements locatifs selon les besoins du lieu.",icon:Building2,image:"/rental.png",span:"md:col-span-4"},
{id:"bureaux",title:"Bureaux et locaux",short:"Des lieux accueillants",long:"Nettoyage des bureaux, espaces de travail et locaux commerciaux.",icon:Building2,image:"/commercial-interior.png",span:"md:col-span-4"},
{id:"commercial",title:"Restaurants et hôtels",short:"Pour votre entreprise",long:"Entretien des restaurants, hôtels, halls et espaces communs, selon les besoins de votre établissement.",icon:Building2,image:"/restaurant.png",span:"md:col-span-4"},
{id:"entretien",title:"Entretien et grand m\u00e9nage",short:"R\u00e9gulier ou ponctuel",long:"Entretien r\u00e9gulier et grand m\u00e9nage pour prendre soin de votre int\u00e9rieur.",icon:Wrench,image:"/housekeeping.png",span:"md:col-span-4"},
{id:"voiture",title:"Int\u00e9rieur de voiture",short:"La propret\u00e9 vous accompagne",long:"Nettoyage de l\u2019habitacle pour retrouver un int\u00e9rieur agr\u00e9able.",icon:Sparkles,image:"/vehicle.png",span:"md:col-span-4"}];

const ServiceCard = ({ s, i }) => {
  const Icon = s.icon;
  return (
    <motion.article initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4 }} className={`service-card ${s.span} col-span-full`} data-testid={`service-card-${s.id}`}>
      <img src={s.image} alt={s.title} loading="lazy" className="service-photo" />
      <div className="service-copy">
        <div className="flex items-center gap-3 mb-5 text-[#0079b5]"><Icon className="h-6 w-6"/><span className="text-sm font-semibold">0{i + 1} / 09</span></div>
        <h3 className="font-display font-bold text-2xl tracking-tight mb-3">{s.title}</h3>
        <p className="text-base text-slate-600 leading-relaxed">{s.long}</p>
        <p className="mt-5 text-sm font-semibold text-[#0079b5]">{s.short}</p>
      </div>
    </motion.article>
  );
};

const Services = () => {
  return (
    <section
      id="services"
      className="relative bg-[#FAFAFA] py-24 md:py-32"
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-14 md:mb-20 grid md:grid-cols-12 gap-8 items-end"
        >
          <div className="md:col-span-6">
            <span className="divider-tag">Nos Services</span>
            <h2 className="mt-6 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#101D2C] leading-[1.02]">
              Neuf services,
              <br />
              <span className="text-[#101D2C]/40">une seule mission&nbsp;:</span>
              <br />
              <span className="relative inline-block">
                votre tranquillité.
                <span className="absolute -bottom-2 left-0 right-0 h-3 bg-[#58BCFA] -z-10" />
              </span>
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8">
            <p className="text-base md:text-lg text-[#475569] leading-relaxed">
              De l'entretien quotidien aux grands chantiers post-construction,
              Entretien Net Pro adapte chaque intervention à votre réalité. Un entretien résidentiel et commercial adapté à vos besoins.
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-12 gap-4 md:gap-6">
          {services.map((s, i) => (
            <ServiceCard key={s.id} s={s} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
